import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { KendoReactDropDownButton } from './KendoReactDropDownButton';

export const KendoReactDropDownButtonBridge = react2angular(
  KendoReactDropDownButton,
  [
    'buttonLabel',
    'type',
    'menuItems',
    'onItemClick',
    'classNames',
    'id',
    'isDisabled'
  ]
);
